import type { Prettify } from '../types';

type Merge<T1, T2> = Prettify<Omit<T1, keyof T2> & T2>;

type MergeArrayOfObject<TArr extends readonly object[], T1 = object> = TArr extends [
  infer T2 extends object,
  ...infer TRest extends object[],
]
  ? MergeArrayOfObject<TRest, Merge<T1, T2>>
  : T1;

/**
 * Merge objects and return a new object
 *
 * @param objects Objects to merge
 *
 * @example
 * const obj1 = { a: 1, b: 2 };
 * const obj2 = { a: 3, d: 4 };
 * const merged = merge(obj1, obj2);
 * // merged = { a: 3, b: 2, d: 4 };
 */
function merge<TArr extends readonly object[]>(...objects: TArr): MergeArrayOfObject<TArr> {
  return Object.assign({}, ...objects);
}

export { merge };
